import { render, staticRenderFns } from "./SocialLoginModal.vue?vue&type=template&id=7479728f&scoped=true&"
import script from "./SocialLoginModal.vue?vue&type=script&lang=js&"
export * from "./SocialLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialLoginModal.vue?vue&type=style&index=0&id=7479728f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479728f",
  null
  
)

export default component.exports